import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/x-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-efceaaf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wearing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "wearing" }, "Wearing", -1))
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "BROKEN!", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "item-description" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "empty-modal-btn-box" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "empty-modal-btn-box" }
const _hoisted_13 = { class: "storage-modal-btn-box" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "custom-modal-expander" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "armor-number-wearing" }, " Armor ", -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "storage-modal-btn-box" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "storage-modal-btn-box" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: _normalizeClass(["wearing-slot", !_ctx.wearing?.name ? 'naked' : '']),
        id: "wearing",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openWearingModal && _ctx.openWearingModal(...args))),
        disabled: _ctx.editMode
      }, [
        _createElementVNode("span", {
          class: _normalizeClass({ broken: _ctx.wearing?.broken })
        }, _toDisplayString(_ctx.wearing?.name || 'Naked!'), 3)
      ], 10, _hoisted_3),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (!_ctx.editMode && _ctx.wearing?.name)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "strip button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openStripModal && _ctx.openStripModal(...args))),
                src: _imports_0
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.wearingModalOpen,
      title: _ctx.wearing?.name,
      onClose: _ctx.closeAllModals
    }, {
      default: _withCtx(() => [
        (_ctx.wearing.broken)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.wearing.description), 1),
        (_ctx.wearing.armor)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Armor: " + _toDisplayString(_ctx.wearing.armor), 1))
          : _createCommentVNode("", true),
        (_ctx.wearing.broken)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "modal-btn green",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.repair && _ctx.repair(...args)))
            }, " Repair "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.stripModalOpen,
      title: _ctx.wearing?.name,
      color: 'lightgreen',
      onClose: _ctx.closeAllModals
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "modal-btn red",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dropArmor && _ctx.dropArmor(...args)))
        }, " Drop "),
        _createElementVNode("button", {
          class: "modal-btn green",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.storeArmor && _ctx.storeArmor(...args)))
        }, " Store ")
      ]),
      _: 1
    }, 8, ["visible", "title", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.emptyArmorModalOpen,
      title: "Get Dressed",
      color: "lightgreen",
      onClose: _ctx.closeAllModals
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openNewArmorModal && _ctx.openNewArmorModal(...args)))
          }, " New Outfit "),
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openArmorInventoryModal && _ctx.openArmorInventoryModal(...args))),
            disabled: _ctx.equippedArmorIndexes.length < 1
          }, " From Inventory ", 8, _hoisted_10),
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openArmorStorageModal && _ctx.openArmorStorageModal(...args))),
            disabled: _ctx.lockerArmorIndexes.length < 1
          }, " From Storage ", 8, _hoisted_11)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.newArmorModalOpen,
      title: "New Outfit",
      color: "lightgreen",
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.newArmorModalOpen = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openStandardArmorModal && _ctx.openStandardArmorModal(...args)))
          }, " Standard "),
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openCustomArmorModal && _ctx.openCustomArmorModal(...args)))
          }, " Custom ")
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.standardArmorModalOpen,
      title: "Standard Outfits",
      color: 'lightgreen',
      onClose: _ctx.closeStandardArmorModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standardArmor, (armor) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("button", {
                class: "modal-btn green",
                onClick: ($event: any) => (_ctx.putOnArmor(armor))
              }, _toDisplayString(armor.name), 9, _hoisted_14)
            ]))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.customArmorModalOpen,
      title: "Custom Outfit",
      color: "lightgreen",
      onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.customArmorModalOpen = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customArmor.name) = $event)),
            placeholder: "Name"
          }, null, 512), [
            [_vModelText, _ctx.customArmor.name]
          ]),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customArmor.description) = $event)),
            placeholder: "Description",
            class: "description-input"
          }, null, 512), [
            [_vModelText, _ctx.customArmor.description]
          ]),
          _createElementVNode("div", null, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              id: "armor-number-wearing",
              class: "number-input",
              type: "number",
              onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validateArmor($event))),
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customArmor.armor) = $event))
            }, null, 544), [
              [_vModelText, _ctx.customArmor.armor]
            ])
          ]),
          _createElementVNode("button", {
            class: "modal-btn green",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.putOnArmor(_ctx.customArmor))),
            disabled: !_ctx.customArmor.name
          }, " Put On ", 8, _hoisted_17)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.armorInventoryModalOpen,
      title: "Inventory",
      color: 'lightgreen',
      onClose: _ctx.closeArmorInventoryModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equippedArmorIndexes, (index) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("button", {
                class: _normalizeClass(["modal-btn green", { broken: _ctx.equipped[index].broken }]),
                onClick: ($event: any) => (_ctx.putOnInventoryArmor(index))
              }, _toDisplayString(_ctx.equipped[index].name), 11, _hoisted_19)
            ]))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_Modal, {
      visible: !_ctx.editMode && _ctx.armorStorageModalOpen,
      title: "Storage",
      color: 'lightgreen',
      onClose: _ctx.closeArmorStorageModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lockerArmorIndexes, (index) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("button", {
                class: _normalizeClass(["modal-btn green", { broken: _ctx.locker[index].broken }]),
                onClick: ($event: any) => (_ctx.putOnStorageArmor(index))
              }, _toDisplayString(_ctx.locker[index].name), 11, _hoisted_21)
            ]))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ], 64))
}